import { AbstractControl, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { AbregelungKopplungsTyp } from '../../../domain/model/abregelung-kopplungs-typ.enum';
import { ControlConfig } from '../form-config.model';
import { AbregelungsinformationenIec101104Adressen } from '../../../domain/model/abregelungsinformationen-iec101104-adressen.model';

export class Iec100104Validator {

    public static readonly allowedValuesTypkennungSollwert = [
        48,
        49,
        50,
        61,
        62,
        63,
    ];
    public static readonly allowedValuesTypkennung100_60_30_0 = [
        45,
        46,
        58,
        59,
    ];
    public static readonly allowedValuesTypkennungBlindWirkleistung = [
        9,
        11,
        13,
        34,
        35,
        36,
    ];

    public static getAllowedTypkennungValues(kopplungsTyp: AbregelungKopplungsTyp) {
        if (kopplungsTyp === AbregelungKopplungsTyp.SOLLWERT) {
            return this.allowedValuesTypkennungSollwert;
        } else if (kopplungsTyp === AbregelungKopplungsTyp.BLINDLEISTUNG_Q ||
            kopplungsTyp === AbregelungKopplungsTyp.WIRKLEISTUNG_P) {
            return this.allowedValuesTypkennungBlindWirkleistung;
        } else {
            return this.allowedValuesTypkennung100_60_30_0;
        }
    }

    public static validateTypkennung(kopplungsTyp: AbregelungKopplungsTyp): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (control.value != null && !isNaN(Number(control.value))) {
                const value = Number(control.value);
                if (kopplungsTyp === AbregelungKopplungsTyp.SOLLWERT) {
                    return this.checkIfIncludes(Iec100104Validator.allowedValuesTypkennungSollwert, value);
                } else if (kopplungsTyp === AbregelungKopplungsTyp.TYP_100 ||
                    kopplungsTyp === AbregelungKopplungsTyp.TYP_60 ||
                    kopplungsTyp === AbregelungKopplungsTyp.TYP_30 ||
                    kopplungsTyp === AbregelungKopplungsTyp.TYP_0) {
                    return this.checkIfIncludes(Iec100104Validator.allowedValuesTypkennung100_60_30_0, value);
                } else if (kopplungsTyp === AbregelungKopplungsTyp.BLINDLEISTUNG_Q ||
                    kopplungsTyp === AbregelungKopplungsTyp.WIRKLEISTUNG_P) {
                    return this.checkIfIncludes(Iec100104Validator.allowedValuesTypkennungBlindWirkleistung, value);
                }
            }
            return null;
        };
    }

    private static checkIfIncludes(array: number[], value: number): { [key: string]: any } | null {
        return array.includes(value) ? null : { wrongTypkennung: true };
    }

    public static allFieldsPresentValidator(requiredField: boolean): ValidatorFn {
        return (formGroup: UntypedFormGroup): ValidationErrors | null => {
            const controls = formGroup.controls as ControlConfig<AbregelungsinformationenIec101104Adressen>;

            if (controls.hohesByte.disabled &&
                controls.mittleresByte.disabled &&
                controls.niedrigesByte.disabled &&
                controls.typkennung.disabled) {
                return null;
            }

            const filledEntries = [
                controls.hohesByte.value,
                controls.mittleresByte.value,
                controls.niedrigesByte.value,
                controls.typkennung.value,
            ].filter(f => f !== undefined && f !== null).length;

            if (filledEntries > 0 && filledEntries < 4) {
                return { fillAllValues: true };
            }
            if (requiredField && filledEntries < 4) {
                return { fillAllValues: true };
            }
            return null;
        };
    }
}
